import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

const AppointmentsPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Randevular" />
      <div className="card">
        <div className="card-body">
          <h5>Randevular</h5>
          <p>Bu sayfa yakında eklenecek.</p>
        </div>
      </div>
    </MasterLayout>
  );
};

export default AppointmentsPage;

